<app-display-card>
  <div
    class="row justify-content-center align-items-center"
    (click)="collapseOwnersBackGroundChecks = !collapseOwnersBackGroundChecks"
  >
    <div class="col">
      <h3>Owner Background Checks</h3>
    </div>

    <div class="col-3 text-end">
      <i
        class="bi bi-chevron-{{
          collapseOwnersBackGroundChecks ? 'up' : 'down'
        }} fs-32 fw-semibold"
      ></i>
    </div>
  </div>

  <div
    class="inner-panel rounded"
    [(ngbCollapse)]="collapseOwnersBackGroundChecks"
  >
    @if (!collapseOwnersBackGroundChecks) {
      <div class="row mx-2">
        <div class="col">
          <div class="row">
            <div class="col-3"></div>
            @for (form of complianceSettingForms; track form) {
              <div class="col-3 d-flex flex-column">
                <label class="form-label align-self-center">{{
                  form && form.controls.riskLevel.value === 0
                    ? 'Global'
                    : 'Risk Level ' + form.controls.riskLevel.value
                }}</label>
              </div>
            }
          </div>
          <div class="row py-2">
            <div class="col-3">
              <label class="form-label">Owner Watchlist</label>
            </div>
            @for (form of complianceSettingForms; track form) {
              <div class="col-3">
                <form [formGroup]="form">
                  <div class="form-group">
                    <select
                      class="form-select"
                      formControlName="ownerWatchlist"
                    >
                      @for (item of ownerWatchlistMap | keyvalue; track item) {
                        <option [ngValue]="item.value">
                          {{ item.key }}
                        </option>
                      }
                    </select>
                  </div>
                </form>
              </div>
            }
          </div>
          <div class="row py-2">
            <div class="col-3">
              <label class="form-label">Owner Felony Search</label>
            </div>
            @for (form of complianceSettingForms; track form) {
              <div class="col-3">
                <form [formGroup]="form">
                  <div class="form-group">
                    <select class="form-select" formControlName="ownerFelony">
                      @for (
                        item of ownerFelonySearchMap
                          | keyvalue: keyValuePairDefaultOrder;
                        track item
                      ) {
                        <option [ngValue]="item.value">
                          {{ item.key }}
                        </option>
                      }
                    </select>
                  </div>
                </form>
              </div>
            }
          </div>
          <div class="row py-2">
            <div class="col-3">
              <label class="form-label">Owner Misdemeanor Search</label>
            </div>
            @for (form of complianceSettingForms; track form) {
              <div class="col-3">
                <form [formGroup]="form">
                  <div class="form-group">
                    <select
                      class="form-select"
                      formControlName="ownerMisdemeanor"
                    >
                      @for (
                        item of ownerMisdemeanorSearchMap
                          | keyvalue: keyValuePairDefaultOrder;
                        track item
                      ) {
                        <option [ngValue]="item.value">
                          {{ item.key }}
                        </option>
                      }
                    </select>
                  </div>
                </form>
              </div>
            }
          </div>
          <div class="row py-2">
            <div class="col-3">
              <label class="form-label">Owner Bankruptcy Search</label>
            </div>
            @for (form of complianceSettingForms; track form) {
              <div class="col-3">
                <form [formGroup]="form">
                  <div class="form-group">
                    <select
                      class="form-select"
                      formControlName="ownerBankruptcy"
                    >
                      @for (
                        item of ownerBankruptcySearchMap | keyvalue;
                        track item
                      ) {
                        <option [ngValue]="item.value">
                          {{ item.key }}
                        </option>
                      }
                    </select>
                  </div>
                </form>
              </div>
            }
          </div>
          <div class="row py-2">
            <div class="col-3">
              <label class="form-label">Owner Liens & Judgements</label>
            </div>
            @for (form of complianceSettingForms; track form) {
              <div class="col-3">
                <form [formGroup]="form">
                  <div class="form-group">
                    <select class="form-select" formControlName="ownerLiens">
                      @for (
                        item of ownerLiensMap
                          | keyvalue: keyValuePairDefaultOrder;
                        track item
                      ) {
                        <option [ngValue]="item.value">
                          {{ item.key }}
                        </option>
                      }
                    </select>
                  </div>
                </form>
              </div>
            }
          </div>
          <div class="row py-2">
            <div class="col-3">
              <label class="form-label">Owner on Sex Offender Registry</label>
            </div>
            @for (form of complianceSettingForms; track form) {
              <div class="col-3">
                <form [formGroup]="form">
                  <div class="form-group">
                    <select
                      class="form-select"
                      formControlName="ownerSexOffender"
                    >
                      @for (
                        item of ownerSexOffenderMap
                          | keyvalue: keyValuePairDefaultOrder;
                        track item
                      ) {
                        <option [ngValue]="item.value">
                          {{ item.key }}
                        </option>
                      }
                    </select>
                  </div>
                </form>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</app-display-card>
